$(document).ready(function(){

	var checkExist = setInterval(function() {
		if ($(".aph_bar_bar").length) {			
			clearInterval(checkExist);
			$("body").addClass("promo-bar-active");
		}
	}, 10);

	$(window).scroll(function () {
		if ($(document).scrollTop() > 200) {
			// $("body").removeClass("promo-bar-active");
		}
	});	

	//open external links in new tab
	var links = document.links;
	for (let i = 0, linksLength = links.length; i < linksLength; i++) {
		if (links[i].hostname !== window.location.hostname) {
			links[i].target = '_blank';
			links[i].rel = 'noreferrer noopener';
		}
	}

	//open menu
	$("#open-menu-button").click(function(){
		//$("#full-menu").slideToggle();
        if($("#open-menu-button").hasClass("menu-open")) {
            $("#full-menu").removeClass("menu-open");
            setTimeout(function(){
				$("#full-menu").addClass("menu-closed"); 
			}, 500);
        } else {
            $("#full-menu").removeClass("menu-closed");
            setTimeout(function(){
				$("#full-menu").addClass("menu-open"); 
			}, 100);
        }
		$("#open-menu-button").toggleClass("menu-open");
	});

});